<section class="col-seleccion">
    <div class="wrap-tabs-seleccion">
        <div id="tabs-gestion">
            <ticketing-tabs class="tabs-gestion"></ticketing-tabs>
        </div>
        <div id="tabs-content-gestion">
            <router-outlet></router-outlet>
          </div>
      </div>
</section>